/**
 * @generated SignedSource<<3fb235a2fbdab15abb6f8e430bb03c41>>
 * @relayHash 2d126b5422e7873c464a0998019dd16d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e922c0b2bb6f0d00b6dae0984f4917b085359e923940c14d807343a859e0df13

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e922c0b2bb6f0d00b6dae0984f4917b085359e923940c14d807343a859e0df13",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
